var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"overflow-x-hidden",attrs:{"title":"Age Verification API | Youverse","transparent":true}},[_c('highlightSection',{attrs:{"backgroundImage":"/storage/images/products/youAge/youverse_age_estimation.jpg","altImage":"YouID Identity Verification Platform","title":"Age estimation API","subtitle":"Low-latency performance, fairness across demographics, and compliance baked in to deploy confidence in every age check.","leftButton":"See how it works","urlLeftButton":"https://6992654.fs1.hubspotusercontent-na1.net/hubfs/6992654/01.%20ONE%20PAGERS/Youverse_YouAge.pdf","imageLeft":true,"leftButtonTargetBlank":true}}),_vm._v(" "),_c('LivenessComparisonSection',{attrs:{"intro":{
      title: 'The age compliance challenge',
      description:
        'From online gaming and gambling to social media and content platforms, regulators demand reliable age verification. Traditional methods add friction and risk. Our Age Estimation API provides a seamless, secure, and accurate solution.',
    },"solution":{
      title: 'YouAge: NIST-benchmarked age estimation API',
      cards: [
        {
          title: 'Regulatory-ready',
          description:
            'Independent benchmarks ensure precise age gating and audit readiness.',
          highlights: [
            'Validated by NIST FRVT/FATE benchmarks — no black-box claims',
            'Optimized MAE in regulated ranges (13–17, 18–21, 25+) for precise age gating.',
            'Equal accuracy across skin tones, genders, and ages.',
          ],
          cta: {
            text: 'See our NIST ranking',
            url: 'https://face.nist.gov/fate/reportcards/aev/youverse_000.html',
            newTab: true,
          },
        },
        {
          title: 'Fast integration',
          description:
            'Deploy age estimation in cloud, edge, or on-prem in minutes.',
          highlights: [
            'SDKs for Web, iOS, and Android — integration in just 3 lines of code.',
            '<1s REST API latency keeps user flows frictionless.',
            'Works in cloud, edge, or on-premises.',
          ],
          cta: {
            text: 'See documentation',
            url: '/docs/1.x/age',
            newTab: true,
          },
        },
        {
          title: 'Private by design',
          description:
            'No storage of biometrics ensures customer data stays safe.',
          highlights: [
            'Encrypted with industry-grade protocols.',
            'No storage of biometrics, IDs, or PII.',
            'Fully aligned with different regulations: GDPR, CCPA, KYC/AML, and gambling regulations.',
          ],
          cta: {
            text: 'Explore our privacy approach',
            url: '/faq',
            newTab: true,
          },
        },
        {
          title: 'Scalable growth',
          description:
            'Validate ROI early, then scale seamlessly — always with predictable costs.',
          highlights: [
            'Micro-pilot (2,000 API calls over 10 days) lets you prove ROI early.',
            'Scales from 10K to 10M+ annual calls with predictable tiers.',
            'Simple per-call billing — no hidden fees, no lock-ins.',
          ],
          cta: {
            text: 'View package tiers',
            url: '/products/youage#products-pricing',
            newTab: false,
          },
        },
        {
          title: 'Compliance built-in',
          description:
            'Continuous updates, partnerships, and industry-specific compliance.',
          highlights: [
            'Continuous NIST submissions.',
            'Partnerships with regulators, standards bodies, and academy.',
            'Industry-specific compliance for gaming, banking, and ID providers.',
          ],
          cta: {
            text: 'Learn more',
            url: 'https://www.youverse.id/resources/blog/age-estimation-for-every-industry',
            newTab: true,
          },
        },
        {
          title: 'Industry-ready',
          description:
            'Accurate, privacy-first verification for sector needs.',
          highlights: [
            'Online gaming, gambling, and betting.',
            'Age-gated content and social media. ',
            'Retail and e-commerce.',
          ],
          cta: {
            text: 'See details',
            url: 'https://www.youverse.id/resources/blog/age-estimation-for-every-industry',
            newTab: true,
          },
        },
      ],
    }}}),_vm._v(" "),_c('section4',{attrs:{"title":"Independently verified","description":"Independently tested and validated against industry standards, ensuring transparency, accountability, and trust with no black-box vendor claims.","images":[
      {
        src: '/storage/images/products/face/nist.png',
        alt: 'NIST',
        style: 'h-8 md:h-10 lg:h-12',
      },
      {
        src: '/storage/images/products/face/GDPR_Compliant.png',
        alt: 'GDPR Compliant',
        style: 'h-8 md:h-10 lg:h-12',
      },
    ]}}),_vm._v(" "),_c('PricingSection',{attrs:{"product-name":"youage","title":"Simple, transparent pricing","description":"Choose the plan that fit your needs. Scale up at your pace."}}),_vm._v(" "),_c('div',{staticClass:"sm:mt-14"},[_c('cta',{attrs:{"title":"Build trust before commitment ","text":"Run a free pilot today and scale confidently to enterprise volumes tomorrow.","buttonText":"Start now","buttonLink":"/products/youage#products-pricing"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }